"use client";

import { ChevronRightCircle } from "lucide-react";

import { JetSmartButton } from "@repo/ui/components/common/forms/JetSmartButton";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@repo/ui/components/ui/dropdown-menu";

import type { PageFooterHeader } from "../../types/cms/common";

interface UserDropdownProps {
  headerContent?: PageFooterHeader["header"];
  userName: string;
  onLogout: () => void;
  onProfile: () => void;
}

export default function UserDropdown({
  headerContent,
  userName,
  onLogout,
  onProfile,
}: UserDropdownProps) {
  return (
    <DropdownMenu data-testid="user-dropdown-dropdown">
      <DropdownMenuTrigger asChild>
        <JetSmartButton
          bgColor="bg-brand-blue"
          data-testid="desktop-header-user-dropdown-btn"
          hoverColor="hover:bg-brand-red"
          textColor="text-white"
          borderColor=""
          iconAlt="Round Arrow"
          icon={<ChevronRightCircle />}
          iconClassName="w-5 h-5"
          className="capitalize"
        >
          {userName}
        </JetSmartButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        sideOffset={8}
        className="w-[180px] p-4 bg-white rounded-3xl shadow-xl border-none z-9999"
        data-testid="user-dropdown-content-section"
      >
        <div className="flex flex-col gap-3" data-testid="user-dropdown-actions">
          <JetSmartButton
            bgColor="bg-brand-blue"
            hoverColor="hover:bg-brand-red"
            textColor="text-white"
            borderColor=""
            iconAlt="Arrow Right"
            icon={<ChevronRightCircle />}
            iconClassName="w-6 h-6"
            iconPosition="right"
            className="w-full font-lato font-medium text-lg leading-[16px] text-center py-4 rounded-full"
            onClick={onProfile}
            data-testid="user-profile-btn"
          >
            {headerContent?.myProfileButtonText}
          </JetSmartButton>

          <JetSmartButton
            bgColor="bg-white"
            hoverColor="hover:bg-gray-50"
            textColor="text-brand-blue"
            borderColor="border-2 border-brand-blue"
            className="w-full font-lato font-medium text-lg leading-[16px] text-center py-4 rounded-full"
            onClick={onLogout}
            data-testid="user-logout-btn"
          >
            {headerContent?.logoutButtonText}
          </JetSmartButton>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
